import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { setLoggedIn } from '@/components/auth/ProtectedRoute';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Loader2 } from 'lucide-react';
import { t } from '@/i18n';
import { OmyaLogo } from '@/components/icons/OmyaLogo';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('petr.nebesar@omya.com');
  const [password, setPassword] = useState('Omya$Pomezi2026!');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoggedIn(true);
      navigate('/kamiony');
    }, 1200);
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center p-4 overflow-hidden">
      {/* Pozadí: fotka s maskou 60% viditelnost */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: 'url(/login-bg.jpeg)' }}
      />
      <div
        className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-chart-1"
        style={{ opacity: 0.4 }}
        aria-hidden
      />
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-24 w-96 h-96 rounded-full bg-[hsl(23,81%,52%)]/5" />
        <div className="absolute bottom-1/4 -right-24 w-80 h-80 rounded-full bg-chart-1/10" />
      </div>

      <Card className="relative z-10 w-full max-w-md bg-white/95 backdrop-blur-xl border-white/20 shadow-2xl">
        <CardContent className="p-8">
          {/* Logo */}
          <div className="flex flex-col items-center gap-2 mb-8">
            <OmyaLogo className="h-10" color="hsl(var(--primary))" />
            <span className="text-[10px] text-muted-foreground tracking-widest">{t('layout.digitalPlant')}</span>
          </div>

          <h2 className="text-lg font-semibold text-center mb-1">{t('login.welcomeBack')}</h2>
          <p className="text-sm text-muted-foreground text-center mb-6">{t('login.signInSubtitle')}</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium">{t('login.email')}</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('login.emailPlaceholder')}
                className="h-11"
              />
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <label className="text-sm font-medium">{t('login.password')}</label>
                <span className="text-xs text-primary cursor-pointer hover:underline">{t('login.forgot')}</span>
              </div>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t('login.passwordPlaceholder')}
                className="h-11"
              />
            </div>

            <Button type="submit" className="w-full h-11 text-sm font-semibold" disabled={loading}>
              {loading ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  {t('login.signingIn')}
                </>
              ) : (
                t('login.signIn')
              )}
            </Button>
          </form>

          <div className="mt-6 flex justify-center">
            <Badge variant="outline" className="bg-amber-50 text-amber-700 border-amber-200 text-xs">
              {t('login.demoMode')}
            </Badge>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
